import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store, i18n } from '@/iti-core-vue';
import vuetify from './plugins/vuetify';
import './plugins/vee-validate';
import './plugins/iti-core-vue';
import $ from 'jquery';
import { localize } from 'vee-validate';
import es from 'vee-validate/dist/locale/es.json';
import en from 'vee-validate/dist/locale/en.json';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';

Vue.config.productionTip = false;

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import '../public/assets/css/dx.generic.lime-light-customized.css';
import publicLayoutModule from './store/modules/public-layout.module';

localize({ es, en,  });

new Vue({
  router,
  store,
  i18n,
  watch:{
    '$route' (to, from){
      publicLayoutModule.setWebTab(to.path);    
    }
  },
  vuetify,
  render: h => h(App)
}).$mount('#app')
